import { jsx as _jsx, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import RichTextViewer from 'components/rich-text-viewer/rich-text-viewer';
const QuestionAnswerShortAnswer = ({ question }) => {
    var _a, _b;
    let { userAnswer } = JSON.parse((_b = (_a = question.questionAnswer) === null || _a === void 0 ? void 0 : _a.rawAnswer) !== null && _b !== void 0 ? _b : '{}');
    userAnswer = userAnswer === undefined ? [] : userAnswer;
    return (_jsx(_Fragment, { children: _jsx("div", Object.assign({ className: "w-100 p-3 border border-1" }, { children: userAnswer && (_jsx(RichTextViewer, { id: `question-${question.id}-answer`, content: userAnswer || '' }, void 0)) }), void 0) }, void 0));
};
export default QuestionAnswerShortAnswer;
